module.exports = __webpack_public_path__ + "img/welcome.45687f4d.png";